import React, { useEffect, useState } from 'react'
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'
import '../../styles/FraseFormadora.css'
import QuizApi from '../../api/QuizApi'
import styled from 'styled-components'

const renderFraseConHuecos = (frase, respuestas, setRespuestas, bloqueado) => {
  const partes = frase.split(/（　）/)
  let resultado = []
  for (let i = 0; i < partes.length; i++) {
    if (partes[i]) {
      resultado.push(<span key={`txt-${i}`}>{partes[i]}</span>)
    }
    if (i < respuestas.length) {
      resultado.push(
        <Droppable droppableId={`hueco-${i}`} key={`hueco-${i}`}>
          {(provided) => (
            <span
              className='hueco-droppable'
              ref={provided.innerRef}
              {...provided.droppableProps}
              onClick={() => {
                if (!bloqueado && respuestas[i]) {
                  const nuevas = [...respuestas]
                  nuevas[i] = null
                  setRespuestas(nuevas)
                }
              }}
              style={{
                display: 'inline-block',
                minWidth: 30,
                minHeight: 30,
                borderBottom: '2px solid #888',
                margin: '0 4px',
                background: '#f8f8f8',
                textAlign: 'center',
                cursor: respuestas[i] ? 'pointer' : 'default',
                maxHeight: '30px'
              }}
            >
              {respuestas[i] || <span style={{ color: '#bbb' }}>___</span>}
              {provided.placeholder}
            </span>
          )}
        </Droppable>
      )
    }
  }
  return resultado
}

const ModoInverso = () => {
  const [frases, setFrases] = useState([])
  const [indiceActual, setIndiceActual] = useState(0)
  const [particulas, setParticulas] = useState([])
  const [respuestas, setRespuestas] = useState([])
  const [resultado, setResultado] = useState(null)
  const [bloqueado, setBloqueado] = useState(false)

  useEffect(() => {
    const obtenerFrases = async () => {
      const cached = sessionStorage.getItem('quiz_inverso')
      if (cached) {
        setFrases(JSON.parse(cached))
        return
      }
      try {
        const data = await QuizApi.fetchQuestions()
        setFrases(data)
        setIndiceActual(0)
        sessionStorage.setItem('quiz_inverso', JSON.stringify(data))
      } catch (error) {
        console.error('Error al obtener frases:', error)
      }
    }
    obtenerFrases()
  }, [])

  useEffect(() => {
    if (frases.length > 0) {
      const frase = frases[indiceActual]
      const opciones = [
        frase.particula_correcta,
        frase.opcion_incorrecta_1,
        frase.opcion_incorrecta_2,
        frase.opcion_incorrecta_3
      ]
        .filter((p) => p && p !== '×')
        .flatMap((grupo) => grupo.split(','))
      const mezcladas = opciones
        .map((txt, i) => ({ id: `p-${i}-${txt}`, texto: txt }))
        .sort(() => Math.random() - 0.5)
      setParticulas(mezcladas)

      // Inicializa respuestas vacías para cada hueco
      const numHuecos = (frase.frase.match(/（　）/g) || []).length
      setRespuestas(Array(numHuecos).fill(null))
      setResultado(null)
    }
  }, [indiceActual, frases])

  const fraseActual = frases[indiceActual]

  const onDragEnd = (result) => {
    if (bloqueado) return // evita cambios si ya está validado
    if (!result.destination) return
    // Solo permitir soltar en huecos
    if (result.destination.droppableId.startsWith('hueco-')) {
      const huecoIdx = parseInt(result.destination.droppableId.split('-')[1], 10)
      const dropped = particulas[result.source.index]
      // Si ya hay esa partícula en otro hueco, no permitir duplicados
      if (respuestas.includes(dropped.texto)) return
      const nuevasRespuestas = [...respuestas]
      nuevasRespuestas[huecoIdx] = dropped.texto
      setRespuestas(nuevasRespuestas)
    }
  }

  // const esRespuestaCorrecta = (respuestasUsuario, correctasRaw) => {
  //   console.log("Validando respuestas:", respuestasUsuario, "Correctas:", correctasRaw);
  //   // correctasRaw puede ser "の,に,から" o "で,へ/に"
  //   let correctasPorHueco = correctasRaw.split(",");
  //   console.log("Validando correctasPorHueco:", correctasPorHueco)
  //   // correctasPorHueco = correctasPorHueco.split("/");
  //   if (respuestasUsuario.length !== correctasPorHueco.length) return false;
  //   respuestasUsuario = respuestasUsuario.map(p => p.split("/"));
  //   console.log("Respuestas del usuario esRespuestaCorrecta:", respuestasUsuario);
  //   return respuestasUsuario.every((resp, idx) => {
  //     const correctas = correctasPorHueco[idx]
  //       .split("/")
  //       .map(p => p.trim());
  //       if(correctas === resp) return true;
  //       console.log("Respuesta:", resp, "Correctas:", correctas);
  //     return correctas.includes(resp);
  //   });
  // };

  const esRespuestaCorrecta = (respuestasUsuario, correctasRaw) => {
    // respuestasUsuario es un array de strings, ej: ["で", "へ", "から"] o ["で", "へ/に", "から"]
    // correctasRaw es un string, ej: "の,に,から" o "で,へ/に"

    console.log('Validando respuestas Usuario:', respuestasUsuario, 'Correctas Raw:', correctasRaw)

    // Divide las respuestas correctas definidas para cada hueco.
    // ej: "で,へ/に,から" -> ["で", "へ/に", "から"]
    const correctasMultiHueco = correctasRaw.split(',')

    if (respuestasUsuario.length !== correctasMultiHueco.length) {
      console.log(
        'Error: La cantidad de respuestas del usuario no coincide con la cantidad de huecos.'
      )
      return false
    }

    // Itera sobre cada respuesta del usuario y compárala con la opción correcta para ese hueco.
    return respuestasUsuario.every((respuestaUsuarioParaEsteHueco, idx) => {
      // respuestaUsuarioParaEsteHueco es la string que el usuario colocó en el hueco (ej: "へ", "に", o "へ/に")
      const opcionesCorrectasStringParaEsteHueco = correctasMultiHueco[idx].trim() // ej: "へ/に" o "の"

      // Divide la string de opciones correctas para este hueco por "/" para obtener un array de respuestas válidas.
      // ej: "へ/に" -> ["へ", "に"]
      // ej: "の" -> ["の"]
      const arrayDeOpcionesCorrectasParaEsteHueco = opcionesCorrectasStringParaEsteHueco
        .split('/')
        .map((p) => p.trim())

      console.log(
        `Hueco ${idx}: Respuesta Usuario='${respuestaUsuarioParaEsteHueco}', Opciones Válidas=${JSON.stringify(
          arrayDeOpcionesCorrectasParaEsteHueco
        )}, String Correcta Original='${opcionesCorrectasStringParaEsteHueco}'`
      )

      // CASO 1: La respuesta del usuario es una de las opciones individuales (ej: "へ" está en ["へ", "に"])
      if (arrayDeOpcionesCorrectasParaEsteHueco.includes(respuestaUsuarioParaEsteHueco)) {
        console.log(`Hueco ${idx}: Coincidencia encontrada (opción individual).`)
        return true
      }

      // CASO 2: La respuesta del usuario es exactamente la cadena combinada (ej: el usuario arrastró "へ/に" y la correcta es "へ/に")
      // Esto es útil si "へ/に" es una opción arrastrable por sí misma.
      // No es estrictamente necesario si tus opciones arrastrables son siempre partículas individuales,
      // pero no hace daño y cubre más casos.
      if (
        opcionesCorrectasStringParaEsteHueco.includes('/') &&
        respuestaUsuarioParaEsteHueco === opcionesCorrectasStringParaEsteHueco
      ) {
        console.log(`Hueco ${idx}: Coincidencia encontrada (cadena combinada completa).`)
        return true
      }

      // Si ninguna de las condiciones anteriores se cumple, la respuesta para este hueco es incorrecta.
      console.log(`Hueco ${idx}: No hubo coincidencia.`)
      return false
    })
  }

  const validar = () => {
    //     console.log("Respuestas:", fraseActual.particula_correcta);
    //     const r = fraseActual.particula_correcta
    //     .split(",")
    //     .join(", ");
    //     console.log("Respuestas 222:", r);

    //     const texto = "で,へ/に,から";
    // const nuevoTexto = texto.replace(/(\p{Script=Hiragana})\/(\p{Script=Hiragana})/gu, "($1/$2)");

    // console.log(nuevoTexto); // → "で,(へ o に),から"

    if (respuestas.some((r) => !r)) {
      setResultado('Completa todos los huecos antes de validar.')
      return
    }
    const esCorrecto = esRespuestaCorrecta(respuestas, fraseActual.particula_correcta)
    console.log('Respuestas del usuario:', respuestas)
    console.log('Respuestas correctas:', fraseActual.particula_correcta)
    console.log('Es correcto:', esCorrecto)
    if (esCorrecto) {
      setResultado('○ ¡Correcto!')
    } else {
      // Mostrar las posibles respuestas correctas para cada hueco
      // let correctas = fraseActual.particula_correcta
      //   .split(",")
      //   .join(", ");
      //   correctas = correctas.replace(/(\p{Script=Hiragana})\/(\p{Script=Hiragana})/gu, "($1/$2)");
      const fraseCompletaStr = fraseActual.frase_completa

      // Divide la cadena por las partículas entre paréntesis, manteniendo los delimitadores.
      // Ej: "ことし(の)しがつ" se convierte en ["ことし", "(の)", "しがつ"]
      const partesConDelimitadores = fraseCompletaStr.split(/(\([^)]+\))/g)

      const elementosRenderizados = partesConDelimitadores
        .filter(Boolean) // Elimina cadenas vacías que puedan surgir del split
        .map((part, index) => {
          // Si la parte es una partícula (empieza con '(' y termina con ')'), la ponemos en negrita.
          if (part.startsWith('(') && part.endsWith(')')) {
            return <strong key={`particle-${index}`}>{part}</strong>
          }
          // Si no, es texto normal. Lo envolvemos en un <span> para mantener la consistencia y asignar una key.
          return <span key={`text-${index}`}>{part}</span>
        })

      setResultado(<>× Incorrecto. Respuesta correcta: {elementosRenderizados}</>)
    }
    setBloqueado(true) // bloquea edición
  }

  const siguiente = () => {
    setIndiceActual((prev) => (prev + 1) % frases.length)
    setBloqueado(false) // desbloquea en nueva frase
  }

  if (frases.length === 0) {
    return <p>Cargando frases...</p>
  }

  return (
    <div style={{ maxWidth: 700, margin: 'auto' }}>
      <h2>Insertar particulaticula</h2>
      <p>
        <strong>Traducción:</strong> {fraseActual.frase_traducida}
      </p>

      <DragDropContext onDragEnd={onDragEnd}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <div className='frase-zone' style={{ minHeight: 50, justifyContent: 'center' }}>
            {renderFraseConHuecos(fraseActual.frase, respuestas, setRespuestas, bloqueado)}
          </div>

          {!bloqueado && (
            <Droppable droppableId='particulas' direction='horizontal'>
              {(provided) => (
                <div className='frase-zone' {...provided.droppableProps} ref={provided.innerRef}>
                  {particulas.map((item, index) => (
                    <Draggable key={item.id} draggableId={item.id} index={index}>
                      {(provided) => (
                        <div
                          className='frase-box'
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          {item.texto}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          )}
        </div>
      </DragDropContext>

      <div style={{ marginTop: 20 }}>
        <div
          style={{
            margin: '0 auto',
            textAlign: 'center',
            marginTop: 20,
            display: 'flex',
            justifyContent: 'center',
            gap: 10
          }}
        >
          {!bloqueado ? (
            <StyledWrapper>
              <button className='shadow__btn_val' onClick={validar}>
                Validar
              </button>
            </StyledWrapper>
          ) : (
            <StyledWrapper>
              <button className='shadow__btn' onClick={siguiente}>
                Siguiente
              </button>
            </StyledWrapper>
          )}
        </div>
      </div>

      {resultado && <p style={{ marginTop: 20 }}>{resultado}</p>}
    </div>
  )
}

const StyledWrapper = styled.div`
  .shadow__btn {
    background-color: #1899d6;
  }
  .shadow__btn_val {
    background-color: #999;
  }
  button {
    appearance: button;
    border: solid transparent;
    border-radius: 16px;
    border-width: 0 0 4px;
    box-sizing: border-box;
    color: #ffffff;
    cursor: pointer;
    display: inline-block;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.8px;
    line-height: 20px;
    margin: 0;
    outline: none;
    overflow: visible;
    padding: 13px 19px;
    text-align: center;
    text-transform: uppercase;
    touch-action: manipulation;
    transform: translateZ(0);
    transition: filter 0.2s;
    user-select: none;
    -webkit-user-select: none;
    vertical-align: middle;
    white-space: nowrap;
  }

  .shadow__btn_val:after {
    background-color: #222;
  }
  .shadow__btn:after {
    background-color: #1cb0f6;
  }
  button:after {
    background-clip: padding-box;
    border: solid transparent;
    border-radius: 16px;
    border-width: 0 0 4px;
    bottom: -4px;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
  }

  button:main,
  button:focus {
    user-select: auto;
  }

  button:hover:not(:disabled) {
    filter: brightness(1.1);
  }

  button:disabled {
    cursor: auto;
  }

  button:active:after {
    border-width: 0 0 0px;
  }

  button:active {
    padding-bottom: 10px;
  }
`

export default ModoInverso
